import { UNIT_KEYS, UNITS, type UnitKey } from '@fewerbags/core';

/** `UNITS.count` has no natural word — everything else falls back to its plural/singular name. */
const OVERRIDE: Partial<Record<UnitKey, string>> = { count: 'count' };

/** Friendly label for a `<select>` option, e.g. "cup" / "tbsp" / "count". */
export function unitLabel(key: UnitKey): string {
  const info = UNITS[key];
  return OVERRIDE[key] ?? info.plural ?? info.singular ?? key;
}

export const UNIT_OPTIONS: ReadonlyArray<{ value: UnitKey; label: string }> = UNIT_KEYS.map(
  (key) => ({ value: key, label: unitLabel(key) }),
);
